<script lang="ts">
    import EncounterComponent from "./Encounter.svelte";
    import { currentEncounters } from "./store";
    import { Danger } from "./types";
</script>

{#if $currentEncounters !== undefined}
    <div class="encounters">
        <EncounterComponent encounter={$currentEncounters[Danger.Easy]} />
        <EncounterComponent encounter={$currentEncounters[Danger.Average]} />
        <EncounterComponent
            encounter={$currentEncounters[Danger.Challenging]}
        />
        <EncounterComponent encounter={$currentEncounters[Danger.Hard]} />
    </div>
{/if}

<style>
    .encounters {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        align-content: center;
    }
    @media (min-width: 768px) {
        .encounters {
            flex-direction: row;
            justify-content: center;
        }
    }
</style>
